<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header d-flex">
      <div class="mr-auto">
        <span class="heading">{{ 'quoteCart.inHurry' | cxTranslate }}</span>
      </div>
      <div class="ml-auto">
        <button
          type="button"
          class="close pt-2"
          aria-label="Close"
          (click)="closeModal('close')"
        >
          <i class="material-icons">close</i>
        </button>
      </div>
    </div>
    <div class="cx-dialog-body modal-body">
      <div class="row">
        <div class="cx-dialog-info col-md-12">
          <p class="fees-para">
            {{ 'quoteCart.fastTrackNoteIs' | cxTranslate }}
            {{ data?.currencyIso }} {{ data.formattedValue }}
            {{ 'quoteCart.fastTrackNote' | cxTranslate }}
          </p>
        </div>
      </div>
    </div>
    <div class="cx-dialog-footer modal-footer">
      <div class="row">
        <div class="col-sm-12 col-md-12 action-container">
          <button class="vs-text-btn cancelBtn" (click)="closeModal('close')">
            {{ 'quoteCart.cancelBtn' | cxTranslate }}
          </button>
          <button
            class="vs-primary-btn"
            (click)="closeModal('submit-fasttrack-quote')"
          >
            <span>
              {{ 'quoteCart.confirmBtn' | cxTranslate }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
